import styled from 'styled-components'

export const ModalWrapper = styled.div`
  .card--modal {
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    align-items: baseline;

    @media(max-width: ${props => props.theme.mediaQuery.smallpc}) {
      padding: 32px 24px;
    }
  }
`

export const Button = styled.div`
  background-color: ${props => props.theme.cores[ 'TAG1-400' ]};
  color: white;

  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1%;
  text-align: center;

  margin-top: 24px;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  padding-top: 11px;
  padding-right: 32px;
  padding-bottom: 11px;
  padding-left: 32px;
`

export const Title = styled.div`
  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -1%;
`

export const Text = styled.div`
  margin-top: 8px;
  
  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
`
